export default {
  activityType: {
    RESTAURANT: "Restaurant",
    ATTRACTION: "Erlebnis",
    GENERIC_SERVICE: "Service",
  },
  cuisine: {
    italian: "Italienisch",
    spanish: "Spanisch",
    canarian: "Kanarisch",
    mediterranean: "Mediterran",
    japanese: "Japanisch",
    chinese: "Chinesisch",
    thai: "Thailändisch",
    indian: "Indisch",
    mexican: "Mexikanisch",
    american: "Amerikanisch",
    french: "Französisch",
    greek: "Griechisch",
    middle_eastern: "Nahost",
    seafood: "Meeresfrüchte",
    steakhouse: "Steakhouse",
    vegetarian: "Vegetarisch/Vegan",
    pizza: "Pizza",
    sushi: "Sushi",
    ramen: "Ramen",
    tapas: "Tapas",
    fast_food: "Fast Food",
    cafe: "Café/Bistro",
    fusion: "Fusion",
    international: "International",
    other: "Sonstige",
  },
  menuCategory: {
    APPETIZER: "Vorspeise",
    FIRST_COURSE: "Erster Gang",
    SECOND_COURSE: "Hauptgericht",
    SIDE_DISH: "Beilage",
    SALAD: "Salat",
    PIZZA: "Pizza",
    SOUP: "Suppe",
    DESSERT: "Dessert",
    FRUIT: "Obst",
    CHEESE: "Käse",
    BEVERAGE: "Getränk",
    WINE: "Wein",
    COCKTAIL: "Cocktail",
    COFFEE: "Kaffee",
    KIDS_MENU: "Kindermenü",
    SPECIAL: "Spezialität",
  },
  lang: {
    en: "Englisch",
    it: "Italienisch",
    es: "Spanisch",
    de: "Deutsch",
  },
} as const;
